module.exports = __webpack_public_path__ + "static/media/mail.6e7c0640.svg";